import { render, staticRenderFns } from "./RelaysMobile.vue?vue&type=template&id=49f91856&"
import script from "./RelaysMobile.vue?vue&type=script&lang=ts&"
export * from "./RelaysMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports